import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'rn-generic-phone',
    standalone: true,
  imports: [CommonModule],
  templateUrl: './new-generic-phone.component.html',
  styleUrl: './new-generic-phone.component.scss',
})
/**
 * size: 'small' | 'medium' | 'large' : Size of the phone with default as 'small' (heigh: 570px, width: 292px),
 * medium (1.2x of small) and large (1.5x of small)
 * stretch: boolean : If true, the phone will be stretched vertically to fit the container
 */
export class NewGenericPhoneComponent {
  @Input() stretch: boolean = false;
  @Input() size?: 'small' | 'medium' | 'large' = 'small';
}
